import ajax from "../utils/request";

const nakedChatApi = {
    /** ********************裸聊专区列表************************* */
    // 商品复选框
    getProductCheckbox(params) {
        return ajax({
            url: '/business/product/checkbox',
            type: 'get',
            params: params
        })
    },
    // 获取裸聊列表
    getNakedChatList(params) {
        return ajax({
            url: '/nude/chat',
            type: 'get',
            params: params
        })
    },
    // 新增
    addNakedChat(params) {
        return ajax({
            url: '/nude/chat',
            type: 'post',
            params: params
        })
    },
    // 修改
    updateNakedChat(params) {
        return ajax({
            url: '/nude/chat',
            type: 'put',
            params: params
        })
    },
    // 官方公告
    nakedChatConfig(params) {
        return ajax({
            url: '/nude/chat/config',
            type: 'get',
            params: params
        })
    },
    // 修改官方公告
    updateNakedChatConfig(params) {
        return ajax({
            url: '/nude/chat/config',
            type: 'put',
            params: params
        })
    },
    // 获取裸聊购买列表
    getNakedChatBuyList(params) {
        return ajax({
            url: '/nude/chat/buy/record',
            type: 'get',
            params: params
        })
    },

    // 获取裸聊购买列表
    confirmUseCode(params) {
        return ajax({
            url: '/nude/chat/use/code',
            type: 'put',
            params: params
        })
    },

    // 获取裸聊举报信息列表
    queryFeedback(params) {
        return ajax({
            url: '/nude/chat/feedback',
            type: 'get',
            params: params
        })
    },
    
    operateFeedback(params) {
        return ajax({
            url: '/nude/chat/feedback/operate',
            type: 'post',
            params: params
        })
    },
}

export default nakedChatApi;